// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import './index.css';
import './App.css';
import './myspace-y2k.css';

import UserSidebar from './components/UserSidebar';
import TopBar from './components/TopBar';
import NavBar from './components/NavBar';
import AdminNavBar from './components/AdminNavBar';
import MobileFooter from './components/MobileFooter'; // <-- ADDED

// user pages
import RankMe from './pages/RankMe';
import MyRankings from './pages/MyRankings';
import MyRankingDetail from './pages/MyRankingDetail';
import CreateList from './pages/CreateList';
import Friends from './pages/Friends';
import FriendRankings from './pages/FriendRankings';
import FriendRankingDetail from './pages/FriendRankingDetail';
import MyFeed from './pages/MyFeed'
import ListPage from './pages/ListPage';
import MyProfile from './pages/MyProfile'; // <-- NEW
import FriendChat from './pages/FriendChat'; // <-- ADDED

// auth
import Login from './components/Login';
import Register from './components/Register';
import AuthLanding from './components/AuthLanding';

// admin pages
import AdminAllLists from './pages/AdminAllLists';
import AdminListDetail from './pages/AdminListDetail';
import AdminSubmissions from './pages/AdminSubmissions';
import AdminSubmissionDetail from './pages/AdminSubmissionDetail';

/* ---------------- Auth helpers ---------------- */
const isAuthed = () => {
  try { return !!localStorage.getItem('username'); } catch { return false; }
};
const isAdmin = () => {
  try { return localStorage.getItem('isAdmin') === 'true'; } catch { return false; }
};

const RequireAuth = ({ children, adminOnly = false }) => {
  if (!isAuthed()) return <Navigate to="/auth" replace />;
  if (adminOnly && !isAdmin()) return <Navigate to="/rank-me" replace />;
  return children;
};

/* ---------------- Frames (chrome) ---------------- */
const UserFrame = ({ children }) => (
  <div className="app-root">
    <TopBar />
    <div className="app-shell">
      <UserSidebar />
      <div className="app-content">
        <div className="scroll-shell">
          <div className="scroll-body">
            <NavBar />
            {children}
            <MobileFooter /> {/* <-- ADDED */}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const AdminFrame = ({ children }) => (
  <div className="app-root">
    <TopBar />
    <div className="app-shell">
      <UserSidebar />
      <div className="app-content">
        <div className="scroll-shell">
          <div className="scroll-body">
            <AdminNavBar />
            {children}
            <MobileFooter /> {/* <-- ADDED */}
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---------------- Router ---------------- */
const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public root: send admins to admin, others to app/auth */}
      <Route
        path="/"
        element={
          isAuthed()
            ? (isAdmin() ? <Navigate to="/admin/lists" replace /> : <Navigate to="/rank-me" replace />)
            : <Navigate to="/auth" replace />
        }
      />

      {/* Auth */}
      <Route path="/auth" element={<AuthLanding />} />
      <Route path="/login" element={isAuthed() ? <Navigate to="/rank-me" replace /> : <Login />} />
      <Route path="/register" element={isAuthed() ? <Navigate to="/rank-me" replace /> : <Register />} />

      {/* -------- USER AREA -------- */}
      <Route
        path="/*"
        element={
          <RequireAuth>
            <UserFrame>
              <Routes>
                <Route path="/feed" element={<MyFeed />} />
                <Route path="/rank-me" element={<RankMe />} />

                {/* Redirect the old page to profile */}
                <Route path="/my-rankings" element={<Navigate to="/my-profile" replace />} />
                <Route path="/my-rankings/:listId" element={<MyRankingDetail />} />

                <Route path="/create-list" element={<CreateList />} />
                <Route path="/my-profile" element={<MyProfile />} /> {/* <-- merged view */}

                <Route path="/friends" element={<Friends />} />
                <Route path="/friends/:username" element={<FriendRankings />} />
                <Route path="/friends/:username/rankings/:listId" element={<FriendRankingDetail />} />
                {/* ✅ Also accept /users/:username/rankings/:listId just in case */}
                <Route path="/users/:username/rankings/:listId" element={<FriendRankingDetail />} />
                <Route path="/friends/:username/chat" element={<FriendChat />} />

                <Route path="/lists/:listId" element={<ListPage />} />
                {/* legacy */}
                <Route path="/rankgame/:listId" element={<ListPage />} />

                <Route path="*" element={<Navigate to="/rank-me" replace />} />
              </Routes>
            </UserFrame>
          </RequireAuth>
        }
      />

      {/* -------- ADMIN AREA -------- */}
      <Route
        path="/admin/*"
        element={
          <RequireAuth adminOnly>
            <AdminFrame>
              <Routes>
                <Route path="/lists" element={<AdminAllLists />} />
                <Route path="/lists/:listId" element={<AdminListDetail />} />
                <Route path="/create-list" element={<CreateList />} />
                <Route path="/submissions" element={<AdminSubmissions />} />
                <Route path="/submissions/:id" element={<AdminSubmissionDetail />} />
                <Route path="*" element={<Navigate to="/admin/lists" replace />} />
              </Routes>
            </AdminFrame>
          </RequireAuth>
        }
      />
    </Routes>
  </BrowserRouter>
);

export default App;
